import React, { createContext, useState, useContext, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  // A kosár tartalmát bookingId-k tömbjeként tároljuk
  // Az állapotot a localStorage-ból töltjük be, hogy megmaradjon az oldalfrissítés után is
  const [cartItems, setCartItems] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedCart = localStorage.getItem('cartItems');
      // Régebbi állapotból (vagy típuseltérésből) megmaradt duplikátumokat itt
      // szűrjük ki, mert egy duplikált bookingId a kosár összesítőjében duplán
      // számolná be az adott tétel árát.
      return savedCart ? [...new Set(JSON.parse(savedCart).map(Number))] : [];
    }
    return [];
  });

  // A kosár tartalmának mentése a localStorage-ba minden változáskor
  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('cartItems', JSON.stringify(cartItems));
    }
  }, [cartItems]);

  // Elem hozzáadása a kosárhoz
  const addToCart = (bookingId) => {
    const id = Number(bookingId);
    setCartItems((prevItems) => {
      if (!prevItems.includes(id)) {
        return [...prevItems, id];
      }
      return prevItems;
    });
  };

  // Elem eltávolítása a kosárból
  const removeFromCart = (bookingId) => {
    const id = Number(bookingId);
    setCartItems((prevItems) => prevItems.filter((itemId) => itemId !== id));
  };

  // Kosár ürítése
  const clearCart = () => {
    setCartItems([]);
  };

  // Ellenőrzés, hogy egy elem benne van-e a kosárban
  const isInCart = (bookingId) => cartItems.includes(Number(bookingId));

  return (
    <CartContext.Provider value={{ cartItems, addToCart, removeFromCart, clearCart, isInCart }}>
      {children}
    </CartContext.Provider>
  );
};

// Custom hook a kosár context használatához
export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
};